const componentStyles = (theme) => ({
  listRoot: {
    height: "100%",
    padding: 0,
  },
  listItemRoot: {
    display: "flex",
    fontSize: ".9rem",
    color: theme.palette.sidebarLinks.main,
    padding: ".4rem 1.5rem .4rem 2.5rem !important",
    "&:hover": {
      color: theme.palette.sidebarLinks.dark,
    },
    "&.Mui-selected": {
      color: theme.palette.sidebarLinks.dark,
    },
  },
  listItemText: {
    marginTop: "0px",
    marginBottom: "0px",
  }


});

export default componentStyles;
